<template>
  <div id="portale-turystyczne">
    <T1HeadScripts rodzajstrony="listaportali" />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <div class="container" id="t1content">
        <a-layout-content>
          <T1PortaleTurystyczneContent />
        </a-layout-content>
      </div>
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1PortaleTurystyczneContent from "./components/T1PortaleTurystyczneContent";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "portale-turystyczne",
  data: () => ({}),
  methods: {},
  mounted() {},
  components: {
    T1HeadScripts,
    T1Header,
    T1PortaleTurystyczneContent,
    T1Footer
  }
};
</script>
